import { IconMessage } from '@tabler/icons-react';
import { Button, Group, Text } from '@mantine/core';

interface IChatFloatingButtonProps {
  onClick?: () => void;
}

export function ChatFloatingButton({ onClick }: IChatFloatingButtonProps) {
  return (
    <Button size="compact-xl" className="shadow" bdrs={999} onClick={onClick}>
      <Group gap="xs">
        <IconMessage />
        <Text fw="bold">Chat</Text>
      </Group>
    </Button>
  );
}
